import React from "react";
import {Button, CardContent, Paper, Stack, Typography} from "@mui/material";
import {LockOutlined} from "@mui/icons-material";
import "./ReviewsLocked.css";

// Placeholder shapes only. Real reviews are never fetched for a guest, so
// there is nothing here to un-blur — the blur is scenery for the CTA, not a
// lock on data that arrived.
const PLACEHOLDER_LINES = [
  ["38%", "26%"],
  ["72%"],
  ["55%", "34%"],
]

type ReviewsLockedProps = {
  onSignIn: () => void
}

export function ReviewsLocked({onSignIn}: ReviewsLockedProps) {
  return (
    <div className="ReviewsLocked">
      <div className="ReviewsLocked-placeholder" aria-hidden="true">
        {[0, 1].map((card) => (
          <Paper key={card} variant="outlined">
            <CardContent>
              <div className="ReviewsLocked-placeholder-header">
                <span className="ReviewsLocked-bar ReviewsLocked-avatar"/>
                <span className="ReviewsLocked-bar" style={{width: "30%"}}/>
              </div>
              <Stack spacing={1} sx={{mt: 1.5}}>
                {PLACEHOLDER_LINES.map((line, index) => (
                  <div key={index} className="ReviewsLocked-placeholder-line">
                    {line.map((width, i) => (
                      <span key={i} className="ReviewsLocked-bar" style={{width}}/>
                    ))}
                  </div>
                ))}
              </Stack>
            </CardContent>
          </Paper>
        ))}
      </div>

      <div className="ReviewsLocked-overlay">
        <LockOutlined className="ReviewsLocked-icon"/>
        <Typography variant="subtitle1" component="div">Reviews are for members</Typography>
        {/* Deliberately not "see what others said" — a park with no reviews yet
            shows this same panel, and that phrasing would promise content. */}
        <Typography variant="body2" color="text.secondary" sx={{mt: 0.5, mb: 2, maxWidth: 320}}>
          Create a free account to read and write reviews.
        </Typography>
        <Button variant="contained" onClick={onSignIn}>Create a free account</Button>
      </div>
    </div>
  )
}
